import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { Box, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { useTrackConversionContext } from 'apps/fleet-planner/context/track-conversion-source'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { AuctionShipment } from 'apps/fleet-planner/types'
import { Card } from 'transfix-ui'
import { MarketplaceDetails } from './MarketplaceDetails'

const useMarketplaceReloadsCardRowStyles = makeStyles(() => ({
  card: {
    borderColor: brandColors.coolGray4,
    borderRadius: 0,
  },
}))

interface IMarketplaceReloadsCardRowProps {
  shipment: AuctionShipment
}

export const MarketplaceReloadsCardRow: FC<IMarketplaceReloadsCardRowProps> = ({ shipment }) => {
  const { trackEvent } = useFMSAnalytics()
  const { setTrackConversion } = useTrackConversionContext()
  const { id } = shipment || {}
  const history = useHistory()
  const viewLoadHandler = () => {
    trackEvent('Reload', 'CLICKED_VIEW_LOAD_FROM_RELOADS_MODAL')
    setTrackConversion('web', 'reloads_post_rate_con_modal')
    history.push(`/book/${id}`)
  }
  const classes = useMarketplaceReloadsCardRowStyles()
  return (
    <Box onClick={viewLoadHandler}>
      <Card className={classes.card}>
        <MarketplaceDetails isEquipmentSectionVisible={false} shipment={shipment} />
      </Card>
    </Box>
  )
}
